import React from "react";

class Contact extends React.Component {
  render() {
    return (
      <React.Fragment>
        {" "}
        <section id="contact" className="add-padding">
          <div className="container text-center">
            <div className="row">
              <div className="col-sm-6 col-md-5 text-right scrollimation fade-up d1">
                <h1 className="big-text">Contact Me</h1>

                <p className="lead">
                  To book an appointment or inquire about services offered
                  <br /> Call or Text
                </p>

                <p>
                  <a href="tel:(949)933-2921" alt="">
                    <i className="fa fa-phone" aria-hidden="true">
                      <span className="h3">(949)933-2921</span>
                    </i>
                  </a>
                </p>
              </div>
              <div className="col-sm-6">
                {" "}
                <p className="h2">
                  Follow me on Instagram | Like me on Facebook!
                </p>
                <hr />
                <ul className="social-links text-center">
                  <li>
                    <a
                      href="https://instagram.com/shawnydouglas?igshid=k54xwt1nsmiu"
                      target="_blank"
                    >
                      <i className="fa fa-instagram fa-fw"></i>
                    </a>{" "}
                  </li>
                  <i className="fa fa-scissors" aria-hidden="true"></i>
                  <li>
                    <a
                      href="https://www.facebook.com/shawnydouglas/"
                      target="_blank"
                    >
                      <i className="fa fa-facebook fa-fw"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
export default Contact;
